import { Plural } from "@lingui/react/macro";
import {
  SectionContainer,
  SectionTitle,
  SectionTitleHeading
} from "@silversea-ssc/ui-components-react";
import ReadMoreList from "components/ReadMoreList/ReadMoreList";
import ShipCard from "components/ShipCard/ShipCard";
import React from "react";
import { VisitingShipFragment } from "types/graphql-types";

type Props = {
  title: string | undefined;
  ships: VisitingShipFragment[];
};

const ShipsSection: React.FC<Props> = ({ title, ships }) => {
  const itemsAlwaysVisible = 2;
  const hiddenShips = ships.length - itemsAlwaysVisible;

  return (
    <SectionContainer
      backgroundColor="neutral05"
      spacingTop="regular"
      spacingBottom="regular"
    >
      <SectionTitle variant="wide">
        <SectionTitleHeading>{title}</SectionTitleHeading>
      </SectionTitle>

      <ReadMoreList
        itemsAlwaysVisible={itemsAlwaysVisible}
        openLabel={
          <Plural
            id="view-more-ships-button"
            value={hiddenShips}
            one="View # more ship"
            other="View # more ships"
          />
        }
        buttonVariant="secondary"
      >
        {ships.map((ship, index) => (
          <ShipCard
            key={ship.id}
            variant={index % 2 ? "left" : "right"}
            ship={ship}
          />
        ))}
      </ReadMoreList>
    </SectionContainer>
  );
};

export default ShipsSection;
